import Link from "@mui/material/Link";
import { styled } from "@mui/material";
import { useDialog } from "_shared/_providers/dialogs/dialog";
import Guid from "_shared/guids/guid";
import { getIndividualsByUserIds } from "marketplace/individuals/_stores/individuals-redux-slice";
import ViewIndividualProfile from "marketplace/individuals/profiles/_views/individual-profile-container";
import { useSelector } from "react-redux";
import TeamTemplate from "work/team-templates/team-template";
import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";


const TeamColumnLink = styled(Link)(({ theme }) => ({
  color: theme.palette.common.black,
  display: "inline-block",
  textDecorationColor: theme.palette.common.black,
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));


type LeaderColumnCellProps = {
  teamTemplate?: TeamTemplate;
  teamUserIds?: Guid[];
  activeTeam?: VendorTeam;
};


export default function LeaderColumnCell(props: Readonly<LeaderColumnCellProps>) {
  const { teamTemplate, teamUserIds, activeTeam } = props;
  const { openDialog, closeDialog } = useDialog();

  let leaderUserId: Guid | undefined;
  let individualsUserIds: Guid[] = [];

  if (activeTeam) {
    leaderUserId = activeTeam.leader?.userId;
    individualsUserIds = [activeTeam.leader?.userId].filter(Boolean) as Guid[];
  } else if (teamTemplate) {
    leaderUserId = teamTemplate.leader?.userId;
    individualsUserIds = [teamTemplate.leader?.userId].filter(Boolean) as Guid[];
  } else if (teamUserIds) {
    individualsUserIds = teamUserIds;
    leaderUserId = teamUserIds[0]; // fallback, not ideal
  }

  const teamIndividualsResponse = useSelector(getIndividualsByUserIds(individualsUserIds));
  const leaderIndividual = leaderUserId
    ? teamIndividualsResponse.find((ind) => ind.userId.isEqualTo(leaderUserId!))
    : undefined;
  if (!leaderIndividual) return null;

  return (
    <TeamColumnLink
      onClick={(event) => {
        event.stopPropagation();
        openDialog({
          component: <ViewIndividualProfile individualId={leaderIndividual.id} />,
          contentSxProps: {
            display: "flex",
          },
          MuiProps: {
            fullWidth: true,
            maxWidth: "lg",
          },
          titleStyle: {
            paddingBottom: 0
          },
          onClose: closeDialog,
        });
      }}
    >
      {leaderIndividual.fullName}
    </TeamColumnLink>
  );
}